<div class="callout-wrapper bg-[#E5E9F2] p-3 sm:p-4 flex flex-col h-full overflow-hidden">

  <!-- Header with Page Title & Child Tab Switcher -->
  <div
    class="bg-white rounded-2xl shadow-sm border border-gray-200 px-4 py-3 mb-3 shrink-0 flex flex-col sm:flex-row sm:items-center justify-between gap-3">

    <!-- Title & Icon -->
    <div class="flex items-center gap-3">
      <div class="w-9 h-9 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center font-bold shadow-xs shrink-0">
        <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      </div>
      <div>
        <h1 class="text-base sm:text-lg font-extrabold text-gray-900 tracking-tight leading-tight">Call Out Management</h1>
        <p class="text-[11px] sm:text-xs text-gray-500 font-medium">Manage Customer Service callout requests & Planning delivery
          approvals</p>
      </div>
    </div>

    <!-- Child Tabs Switcher & Actions -->
    @if (userRole() != 'none') {
    <div class="flex flex-wrap items-center gap-2.5 shrink-0">

      <!-- Create New Call Out Button (Active in CS Mode) -->
      @if (activeTab() === 'cs') {
      <button type="button" (click)="callOutView.openCreateModal()"
        class="px-3.5 py-2 bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white text-xs font-bold rounded-xl shadow-sm hover:shadow transition-all duration-150 flex items-center gap-1.5 cursor-pointer">
        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M12 4v16m8-8H4" />
        </svg>
        New Call Out
      </button>
      }

      <!-- Switcher (CS vs Planning) -->
      <div class="inline-flex p-1 bg-gray-100/90 rounded-xl border border-gray-200/80 shadow-inner">
        @if (userRole() === 'cs' || userRole() === 'full') {
        <button type="button" (click)="setTab('cs')" [class.bg-white]="activeTab() === 'cs'"
          [class.text-blue-700]="activeTab() === 'cs'" [class.shadow-sm]="activeTab() === 'cs'"
          [class.font-bold]="activeTab() === 'cs'" [class.text-gray-600]="activeTab() !== 'cs'"
          class="px-4 py-1.5 text-xs rounded-lg font-medium transition-all duration-200 flex items-center gap-1.5 cursor-pointer">
          <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
          CS Call Out
        </button>
        }

        @if (userRole() === 'planning' || userRole() === 'full') {
        <button type="button" (click)="setTab('planning')" [class.bg-white]="activeTab() === 'planning'"
          [class.text-indigo-700]="activeTab() === 'planning'" [class.shadow-sm]="activeTab() === 'planning'"
          [class.font-bold]="activeTab() === 'planning'" [class.text-gray-600]="activeTab() !== 'planning'"
          class="px-4 py-1.5 text-xs rounded-lg font-medium transition-all duration-200 flex items-center gap-1.5 cursor-pointer">
          <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
          </svg>
          Planning Call Out
        </button>
        }
      </div>

    </div>
    }
  </div>

  <!-- Reusable Call Out View Component rendering active interface -->
  <app-call-out-view #callOutView [pageType]="activeTab()" [userRole]="userRole()" class="flex-1 min-h-0 flex flex-col"></app-call-out-view>

</div>